import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ReminderModel} from "app/dar/common/services/reminder/reminder.model";
import {ActivatedRoute, Router} from "@angular/router";


@Component({
  selector: 'app-reminder-list',
  templateUrl: './reminder-list.component.html',
  styleUrls: ['./reminder-list.component.scss']
})
export class ReminderListComponent implements OnInit {
  reminders: ReminderModel[]


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ReminderModel[],
    private dialogRef: MatDialogRef<ReminderListComponent>,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.reminders = data || [];
  }

  ngOnInit(): void {
  }

  edit(uuid: string) {
    // Reminder: router is a singleton, and it is not easy to make a service that extend Router
    // backup default router value
    const previousOnSameUrlNavigation = this.router.onSameUrlNavigation;
    const previousShouldReuseRoute = this.router.routeReuseStrategy.shouldReuseRoute
    // alter router to reload the same page with different parameters
    this.router.onSameUrlNavigation = 'reload';
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.router
      .navigate(['/consultation', {id: uuid, openComment: true}], {relativeTo: this.route.parent})
      .then(() => {
        // restore default router value
        this.router.onSameUrlNavigation = previousOnSameUrlNavigation;
        this.router.routeReuseStrategy.shouldReuseRoute = previousShouldReuseRoute;
      });
    this.dialogRef.close();
  }
}
